/**
 * User: hella
 * Date: 6/3/14
 * Time: 8:30 AM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */

'use strict';

module.exports = {
    GLOBAL_NAV_WRAP            : '#globalNav',
    GLOBAL_NAV                 : '.global-nav-content-width',
    GLOBAL_NAV_ITEM            : '.global-nav-item',
    GLOBAL_NAV_ITEM_LINK       : '.global-nav-item-link',
    GLOBAL_SEARCH              : '#globalSearchBox',
    HEADER                     : '#header',
    HEADER_DIVIDER             : '#headerDivider',
    TOGGLE_USER_NAV            : '#toggleUserNav',
    TOGGLE_NAV_SEARCH          : '#toggleNavSearch',
    TOGGLE_NAV_FAVORITES       : '#toggleNavFavorites',
    TOGGLE_NAV_CART            : '#toggleCart',
    NAV_UTILS_WRAP             : '.nav-utils-wrap',
    SEARCH_BOX_FORM            : '.search-box-form',
    SEARCH_BOX_INPUT           : '.search-box-input',
    SEARCH_BOX_BUTTON          : '.search-box-button',
    SEARCH_BOX_CALLOUT         : '.js-search-box-callout',
    SEARCH_INPUT               : '#globalSearchBox .search-box-input',
    SEARCH_CLOSE               : '.js-search-close',
    HANDLER_SEARCH             : 'a[href=#search]',
    HANDLER_REGISTER           : 'a[href=#register]',
    HANDLER_LOGIN              : 'a[href=#login]',
    HANDLER_LOGOUT             : 'a[href=#logout]',
    HANDLER_USER_NAV           : 'a[href=#user]',
    MAX_USER_NAME_LENGTH       : 10,
    MAX_MASQUERADE_NAME_LENGTH : 12,
    // anything appended with Class has no preceding period
    DOUBLE_TAP_CLASS           : 'js-double-tap',
    SCROLLED_CLASS             : 'scrolled',
    IS_FULL_CLASS              : 'is-full',
    IS_SHOWING_CLASS           : 'is-showing',
    IS_CURRENT_CLASS           : 'is-current',
    IS_HOVER_CLASS             : 'is-hover',
    SEARCH_EXPANDED_CLASS      : 'search-expanded',
    // Nav sub views
    SUB_VIEW_GLOBAL            : 'NavGlobalView',
    SUB_VIEW_GLOBAL_SUBS       : 'NavGlobalSubsView',
    SUB_VIEW_UTILS             : 'NavUtilsView',
    SUB_VIEW_SEARCH            : 'NavSearchView',
    SUB_VIEW_USER              : 'NavUserView',
    SUB_VIEW_FAVORITES         : 'NavFavoritesView',
    SUB_VIEW_CART              : 'NavCartView'
};



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/core/nav/constants.js
// module id = 1460
// module chunks = 63